/**
 * dashboard/select2.js — Select2 для всех селектов (class="select2"):
 * одиночный выбор и multiple. Инициализация идемпотентна: уже инициализированные
 * селекты пропускаются, поэтому можно вызывать повторно на динамическом контенте
 * (окна «на лету» вызывают window.initAdminSelects после вставки HTML).
 * Плагин сам не подключает — require("select2") + i18n лежат во входе dashboard.js.
 * Публичный API: window.initAdminSelects(root) — root — DOM/jQuery/селектор, null — весь document.
 */
'use strict';

(function () {
    function initSelect2In(root) {
        if (!jQuery.fn.select2) {
            return;
        }

        let scope = root ? jQuery(root) : jQuery(document);
        scope.find("select.select2").each(function () {
            let select = jQuery(this);
            if (select.data("select2")) {
                return; // уже инициализирован
            }
            // dropdownParent в body: в окнах «на лету» дропдаун не обрезается .modal-body (overflow-y: auto),
            // z-index выше модалки задаётся в select2.scss.
            select.select2({ language: "ru", dropdownParent: jQuery(document.body) });
        });
    }

    /** Инициализация Select2 в пределах root (без аргумента — весь document). */
    window.initAdminSelects = function (root) {
        initSelect2In(root);
    };
})();

jQuery(document).ready(function () {
    window.initAdminSelects();
});
